import ArchiveIcon from '@mui/icons-material/Archive';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MessageIcon from '@mui/icons-material/Message';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SaveIcon from '@mui/icons-material/Save';
import SellIcon from '@mui/icons-material/Sell';

import { ApplicationActionButton } from '@features/applications';

export const applicationActionButtons: ApplicationActionButton[] = [
  {
    color: 'primary',
    label: 'Message',
    Icon: MessageIcon,
    actionType: 'messenger',
  },
  {
    color: 'green',
    label: 'Move to Saved',
    Icon: SaveIcon,
    actionType: 'save',
    hideOnStatus: ['saved', 'archived'],
  },
  {
    color: 'secondary',
    label: 'Reschedule interview',
    Icon: QuestionAnswerIcon,
    actionType: 'invite to interview block',
    hideOnStatus: ['unattended', 'saved', 'declined', 'hired', 'job offer', 'archived', 'messaged', 'job offer decline', 'withdraw application'],
  },
  {
    color: 'secondary',
    label: 'Interview',
    Icon: QuestionAnswerIcon,
    actionType: 'invite to interview block',
    hideOnStatus: ['interview process', 'archived'],
  },
  {
    color: 'lightPurple',
    label: 'Send Job Offer',
    Icon: CheckIcon,
    actionType: 'hire',
    hideOnStatus: ['hired', 'archived'],
  },
  {
    color: 'error',
    label: 'Move to Declined',
    Icon: CloseIcon,
    actionType: 'decline',
    hideOnStatus: ['declined', 'archived'],
  },
  {
    color: 'dark',
    label: 'Move to Archived',
    Icon: ArchiveIcon,
    actionType: 'archive',
    hideOnStatus: ['archived'],
  },
  // todo: uncomment this when tags implemented
  // {
  //   color: 'info',
  //   label: 'Manage Tags',
  //   Icon: SellIcon,
  //   actionType: 'tags',
  // },
];
